import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);
  const language = translateService.currentLang || translateService.defaultLang;
  const httpRequest = req.clone({
    setHeaders: {
      'Accept-Language': language,
    },
  });
  return next(httpRequest);
};
